import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

// Получить сигналы по фильтру
export const apiGetSignalsFiltered = async (filterName, nextUrl = null) => {
  let url;
  
  if (nextUrl) {
    // Если передан URL следующей страницы, используем его
    url = nextUrl;
  } else {
    // Иначе создаем новый URL с фильтром
    url = `${backendUrl}/api/signals/?filter=${filterName}`;
  }

  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetchWithAuth(url, options);

    if (!response.ok) {
      throw new Error(
        `Ошибка сети при получении сигналов по фильтру "${filterName}": ${response.status}`
      );
    }

    return await response.json();
  } catch (error) {
    console.error('Ошибка API фильтрации сигналов:', error);
    throw error;
  }
};